import React from 'react';

import classes from './ToolbarButton.module.scss';

interface ToolbarButtonProps {
	onClick: () => void;
	title: string;
	isActive?: boolean;
	className?: string;
	children: React.ReactNode;
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
	onClick,
	title,
	isActive = false,
	className = '',
	children,
}) => {
	return (
		<button
			type='button'
			onClick={onClick}
			className={`${classes.toolbarButton} ${isActive ? classes.active : ''} ${className}`}
			title={title}
		>
			{children}
		</button>
	);
};
